"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTimeout = exports.useManagerTimeout = void 0;
const initializer_1 = require("../../initializer");
const useManagerTimeoutBase_1 = require("./useManagerTimeoutBase");
const useManagerTimeout = () => {
    return (0, useManagerTimeoutBase_1.useManagerTimeoutBase)(initializer_1.TimeOut);
};
exports.useManagerTimeout = useManagerTimeout;
exports.useTimeout = exports.useManagerTimeout;
//# sourceMappingURL=useManagerTimeout.js.map